import { useSearchParams,Link } from "react-router-dom";
import log from "../../../sitel/commons/services/log";
import authCentral from "../../../services/authCentral";
import { MEDSTAR_ASSOCIATION_TYPE__ASSOCIATE } from "../../../sitel/commons/utilities/medstarAssociationType";
import useOriginApp from "../../../services/useOriginApp"


export default function ContinueAuth(){
    const [searchParams, ] = useSearchParams();
    const authCode = searchParams.get('code');
    const originAppIdentifier = searchParams.get('state');
    const originApp = useOriginApp(originAppIdentifier);
    
    async function startAuthFlow(){
      log.debug(`Authenticating SSO flow with code ${authCode}`);
      const success = await authCentral.loadJWTFromServer(authCode,`&medstar-association-type=${MEDSTAR_ASSOCIATION_TYPE__ASSOCIATE}`);
      if(success && authCentral.getCurrentUser()){
        window.location.href = originApp.url;
      } else {
        console.error('An error occured while loging you in. TODO this flow')
        // TODO : navigate to try again, or error message? navigate(`${baseUrl}/step5/profile`);
      }
    }

    if(authCode){        
      startAuthFlow();
    } else if(originApp){
      window.location.href = originApp.url;
    } else {
      window.location.href = '/central';
    }
    
    //temp
    return (
        <span>
            Loging in ... <Link to={`/${originApp}/auth`}>Please try again if nothing happens after few seconds</Link> ... 
        </span>
    );
}
